/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './strongRef.defs'
export { main as default } from './strongRef.defs'
